<template>
  <div
    :class="['text-loader', position == 'right' ? 'text-loader--right' : '']"
  >
    <svg
      id="dots"
      width="132px"
      height="58px"
      viewBox="0 0 132 58"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
    >
      <title>dots</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        sketch:type="MSPage"
      >
        <g id="dots" sketch:type="MSArtboardGroup" fill="#0084ff">
          <circle
            id="dot1"
            sketch:type="MSShapeGroup"
            cx="25"
            cy="30"
            r="13"
          ></circle>
          <circle
            id="dot2"
            sketch:type="MSShapeGroup"
            cx="65"
            cy="30"
            r="13"
          ></circle>
          <circle
            id="dot3"
            sketch:type="MSShapeGroup"
            cx="105"
            cy="30"
            r="13"
          ></circle>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "TextLoader",
  props: {
    position: String
  }
};
</script>

<style scoped lang="scss">
@keyframes load {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.text-loader {
  box-shadow: 0 3px 13px 0 rgba($txt-color, 0.1);
  border-top-left-radius: 7px !important;
  background-color: $color-bg;
  justify-content: center;
  border-radius: 20px;
  margin-bottom: 10px;
  align-items: center;
  padding: 10px 15px;
  margin-right: auto;
  margin-left: 40px;
  margin-top: 10px;
  display: flex;
  width: 70px;

  svg {
    height: auto;
    width: 40px;
  }

  #dots #dot1 {
    animation: load 1.2s infinite;
  }

  #dots #dot2 {
    animation: load 1.2s infinite;
    animation-delay: 0.3s;
  }

  #dots #dot3 {
    animation: load 1.2s infinite;
    animation-delay: 0.6s;
  }

  &--right {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 7px !important;
    margin-right: 10px;
    margin-left: auto;
  }
}
</style>
